import { createPermissionComboboxOptions } from '@bo-utils/user';
import { useGetPermissionsQuery } from '@bo-services/permissionsApi';
import { useMemo } from 'react';

export const usePermissions = () => {
  const {
    data: permissionsData,
    isError: isPermissionsError,
    isLoading,
    isFetching
  } = useGetPermissionsQuery();

  const permissionComboboxOptions = useMemo(
    () => createPermissionComboboxOptions(permissionsData),
    [permissionsData]
  );

  return {
    isPermissionsLoading: isLoading || isFetching,
    isPermissionsError,
    permissionComboboxOptions,
    permissionsData
  };
};
